import { useContext, useEffect, useRef } from "react";
import { AuthContext } from "@/context/AuthContext";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import { toast } from "react-toastify";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { useNavigate } from "react-router-dom";

export function useUser() {
  const { i18n } = useTranslation();
  const { setAuthUser, authUser } = useContext(AuthContext);
  const fetchingUser = useRef(false);
  const { data, refetch, isFetching, isFetched, isError, error } =
    useCurrentUserQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (!authUser) {
      refetch();
    }
  }, [authUser]);

  useEffect(() => {
    if (isFetching) fetchingUser.current = true;
    if (isFetched && !isFetching && fetchingUser.current) {
      const user = data?.data?.data ? data.data.data : null;
      fetchingUser.current = false;
      setAuthUser(user);
      if (user && !user.isVerified && !window.location.pathname.includes("collaborator")) {
        navigate("/verify-email");
      }
      if (!user) {
        if (isError && error.response?.data.code !== 401) {
          toast.error(errorKeyFormate(error.response?.data.message+''), {
            toastId: "toast2",
            ...errorConfig,
          });
          navigate("/login");
        }
      }
      if (user) {
        i18n.changeLanguage(user.language?.toLowerCase());
        localStorage.setItem(
          "organisation-id",
          user.userOrganisation[0]?.organisationId
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching, setAuthUser]);

  return { user: authUser , isError };
}
